import React from 'react';
import { Chip } from '@mui/material';
import DirectoryStatus from 'store/enums/DirectoryStatus';

interface DirectoryStatusChipProps {
  status?: string | null;
}

const statusChipStyles = {
  width: '100%',
  justifyContent: 'center',
};

const DirectoryStatusChip: React.FunctionComponent<DirectoryStatusChipProps> = ({ status }) => {
  const normalizedStatus = status?.trim();

  switch (normalizedStatus) {
    case DirectoryStatus.Approved:
      return <Chip label={DirectoryStatus.Approved} color={'success'} size={'small'} sx={statusChipStyles} />;

    case DirectoryStatus.Submit:
    case DirectoryStatus.Pending:
      return <Chip label={DirectoryStatus.Pending} color={'warning'} size={'small'} sx={statusChipStyles} />;

    case '':
    case undefined:
      return null;

    default:
      return (
        <Chip label={normalizedStatus} color={'default'} size={'small'} variant={'outlined'} sx={statusChipStyles} />
      );
  }
};

export default DirectoryStatusChip;
